import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { PATIENT_WAITING_LIST } from "@/api_framework/api_config";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import {
  ITeleconsultationUserDoctorMeetDetailsPostResponse,
  ITeleconsultationUserDoctorMeetDetailsResponsePostBody,
} from "@/api_framework/api_modals/Patients";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useDoctorUserMeetDetailsMsgAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (filterBody: ITeleconsultationUserDoctorMeetDetailsResponsePostBody) => {
      try {
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(`${PATIENT_WAITING_LIST?.TELECONSULTATION_USER_DOCTOR_MEET_DETAILS?.baseURL}`, filterBody, {
            headers: {
              "X-Internal-API-Key": `@#INTERNAL325547API32676$%KEY0982*#%kjdgewiuTYIIBI876`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ITeleconsultationUserDoctorMeetDetailsPostResponse>) => {
            if (res.data.status === true) {
              toast.success(res.data.message);
              return { status: true, message: "batch" };
            } else {
              return { status: false, message: "product_not_filtered" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: "product_not_filtered" };
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch, configuration.localStorage.ACCESS_TOKEN.key],
  );

  return { execute };
};
